var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C3.15 0 0 3.15 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.15 10.85 0 7 0ZM6.99975 9.5C5.59975 9.5 4.50022 8.4 4.50022 7C4.50022 5.6 5.60083 4.5 6.99975 4.5C8.39868 4.5 9.49929 5.6 9.49929 7C9.49929 8.4 8.39975 9.5 6.99975 9.5Z",
    fill: "#6d4096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.3c371e299794f1ec49380157f1ee1bf0.svg";
export { ForwardRef as ReactComponent };